/**
 * accountSummary.service.ts
 *
 * Read-only account summary for Admin → Account → Details. Reproduces the lower
 * box on the legacy admin_account_details.php screen. Backed by
 * /api/v5/account-summary (AccountSummaryController). Thin apiClient wrapper.
 */
import { apiClient } from './apiClient';
import type { ApiResponse } from '@/types/api.types';

export interface AccountSummary {
  accountName: string;
  leadEmail: string;
  commLogEmailDomain: string;
  commLogPhone: string;
  confirmationPhone: string;
  counts: {
    users: number;
    doctors: number;
    coordinators: number;
    nurses: number;
  };
  roleTitles: {
    doctor: string;
    coordinator: string;
    nurse: string;
  };
}

export function getAccountSummary(): Promise<AccountSummary> {
  return apiClient
    .get<ApiResponse<AccountSummary>>('/account-summary')
    .then((r) => r.data.data);
}
